import charlsFactory from '@cornerstonejs/codec-charls/decodewasmjs';
const charlsWasm = new URL('@cornerstonejs/codec-charls/decodewasm', import.meta.url);
import getPixelData from './getPixelData.js';
import { resolveWasmUrl, setWasmBasePathFromConfig } from '../wasmBasePath.js';
const local = {
    codec: undefined,
    decoder: undefined,
    decodeConfig: {},
};
function getExceptionMessage(exception) {
    return typeof exception === 'number'
        ? local.codec.getExceptionMessage(exception)
        : exception;
}
export function initialize(decodeConfig) {
    local.decodeConfig = decodeConfig;
    setWasmBasePathFromConfig(decodeConfig);
    if (local.codec) {
        return Promise.resolve();
    }
    const charlsModule = charlsFactory({
        locateFile: (f) => {
            if (f.endsWith('.wasm')) {
                return resolveWasmUrl('charlswasm_decode.wasm', charlsWasm);
            }
            return f;
        },
    });
    return new Promise((resolve, reject) => {
        charlsModule.then((instance) => {
            local.codec = instance;
            local.decoder = new instance.JpegLSDecoder();
            resolve();
        }, reject);
    });
}
async function decodeAsync(compressedImageFrame, imageInfo) {
    try {
        await initialize();
        const decoder = local.decoder;
        const encodedBufferInWASM = decoder.getEncodedBuffer(compressedImageFrame.length);
        encodedBufferInWASM.set(compressedImageFrame);
        decoder.decode();
        const frameInfo = decoder.getFrameInfo();
        const interleaveMode = decoder.getInterleaveMode();
        const nearLossless = decoder.getNearLossless();
        const decodedPixelsInWASM = decoder.getDecodedBuffer();
        const encodedImageInfo = {
            columns: frameInfo.width,
            rows: frameInfo.height,
            bitsPerPixel: frameInfo.bitsPerSample,
            signed: imageInfo.signed,
            bytesPerPixel: imageInfo.bytesPerPixel,
            componentsPerPixel: frameInfo.componentCount,
        };
        const pixelData = getPixelData(frameInfo, decodedPixelsInWASM, imageInfo.signed);
        const encodeOptions = {
            nearLossless,
            interleaveMode,
            frameInfo,
        };
        return {
            ...imageInfo,
            pixelData,
            imageInfo: encodedImageInfo,
            encodeOptions,
            ...encodeOptions,
            ...encodedImageInfo,
        };
    }
    catch (error) {
        throw getExceptionMessage(error);
    }
}
export default decodeAsync;
